import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';

import { SettingsSection, FullWidthDivider } from 'legacyComponents/styled/lib';
import { useAppManager } from 'core/hooks';
import { SectionTitle } from 'apps/group/styles';
import { useClientStore } from 'apps/hooks';

import { Spinner } from 'components';
import { CreateTeamCard } from 'apps/onboarding/subscription/createTeamCard';

import { CollaboratorsOverview } from '../views/collaboratorsOverview';
import { CollaboratorsManager } from './appManager';

export const Collaborators = observer(() => {
  const collaboratorManager = useAppManager(CollaboratorsManager);
  const clientStore = useClientStore();
  const { isWiderThanMD } = clientStore.breakPointManager;

  useEffect(() => {
    collaboratorManager.QueryCollaborators();
  }, []);

  if (!clientStore.signedInProfile?.inSpace?.hasProSubscription) {
    return null;
  }

  return (
    <>
      <SettingsSection>
        <SectionTitle level={2} size='medium'>
          <Trans>Editors</Trans>
        </SectionTitle>
        {collaboratorManager.loading !== false ? (
          <Spinner margin='20px auto' />
        ) : (
          <>
            <FullWidthDivider margin='0px 0px 20px 0px' />
            <div className='md:flex md:justify-between'>
              {collaboratorManager.collaborators?.length ? (
                <CollaboratorsOverview
                  className='md:w-5/12 h-64'
                  collaborators={collaboratorManager.collaborators}
                />
              ) : (
                <span className='text-black'>
                  You have no collaborators yet.
                </span>
              )}

              {isWiderThanMD &&
                collaboratorManager.collaborators.length > 0 && (
                  <div className='flex md:px-4 flex-col items-center border rounded border-gray-300 px-24 py-6 h-64 ml-2 md:w-6/12'>
                    <CreateTeamCard />
                  </div>
                )}
            </div>
          </>
        )}
      </SettingsSection>
    </>
  );
});
